import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailLeftMask = styled.div<React.CSSProperties>`
  background: linear-gradient(90deg, #000 60.82%, rgba(19, 19, 19, 0) 76.33%);
  position: absolute;
  height: ${Screen.widthRatio * 799}px;
  width: ${Screen.widthRatio * 974}px;
`;

export default DetailLeftMask;
